﻿<script lang="ts">
    import {List, ListGroup, ListItem} from "framework7-svelte";
    import {createEventDispatcher} from "svelte";
    import { _ } from "svelte-i18n";
    
    import FloatingButton from "../FloatingButton.svelte";

    const HERE_TRAFFIC_OPTIONS: {label: string, value: string}[] = [
        {label: $_("shared.DONT_DISPLAY"), value: 'none'},
        {label: $_("pages.project.HERE_TRAFFIC_COVERAGE"), value: 'coverage'},
        {label: $_("pages.project.HERE_TRAFFIC_SPEED_HQ"), value: 'speedhq'},
        {label: $_("pages.project.HERE_TRAFFIC_SPEED_LQ"), value: 'speedlq'},
        {label: $_("pages.project.HERE_TRAFFIC_CONGESTION_HQ"), value: 'congestionhq'},
        {label: $_("pages.project.HERE_TRAFFIC_CONGESTION_LQ"), value: 'congestionlq'}
    ];
    
    let selectedTrafficFlowMode = 'none';

    const eventDispatcher = createEventDispatcher();

    function selectTrafficFlowMode(trafficFlowMode: string) {
        selectedTrafficFlowMode = trafficFlowMode;
        eventDispatcher('trafficFlowModeSelected', trafficFlowMode);
    }
    
</script>

<FloatingButton
        label="Here traffic"
        active={selectedTrafficFlowMode !== 'none'}
        activeIcon="check"
        inactiveIcon=""
        popoverWidth="348px">

    <List ul={false}>
        <ListGroup>
            <ListItem title="{$_('pages.project.HERE_TRAFFIC_DISPLAY')}" groupTitle />

            {#each HERE_TRAFFIC_OPTIONS as option}
                <ListItem
                        radio
                        radioIcon="end"
                        value={option.value}
                        title={option.label}
                        checked={selectedTrafficFlowMode === option.value}
                        on:change={() => selectTrafficFlowMode(option.value)}/>
            {/each}

        </ListGroup>
    </List>

</FloatingButton>
